module.exports = __webpack_public_path__ + "app/principal/widgets/create-button-3QAvpaC4.html";